import React from 'react';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LoginPage from './LoginPage';
import Home from './Home';

function Main(props) {
  const { loggedIn } = props;

  return (
    <Router>
      <Route
        path="/"
        render={({ location }) => (
          <div>
            {!loggedIn && location.pathname !== '/login' && <Redirect to="/login" />}
            {loggedIn && location.pathname !== '/' && <Redirect to="/" />}
            <Route path="/login" component={LoginPage} />
            <Route path="/" exact component={Home} />
          </div>
        )}
      />
    </Router>
  );
}

Main.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  loggedIn: state.auth.loggedIn,
});

export default connect(mapStateToProps)(Main);
